import React, { useMemo, useRef } from 'react';
import styled from 'styled-components/macro';

import Container from '../Container';
import { getVh } from '../utils';
import useParallax from '../useParallax';
import useTriggerAnimation from '../useTriggerAnimation';

const Critter = styled.img`
  aspect-ratio: 47/32;
  height: auto;

  min-width: 120rem;
  max-width: 160rem;
  width: 13vw;
`;

const Bee = () => {
  const ref = {
    figure: useRef<HTMLElement>(null),
    img: useRef<HTMLImageElement>(null)
  }

  const top = useMemo(() => getVh("history", 0.2), []);

  useTriggerAnimation(ref.figure, top);
  useParallax(ref.img, top, 450);

  return (
    <Container
      ref={ref.figure}
      top={top}
      style={{ left: "10vw" }}
    >
      <Critter
        ref={ref.img}
        src="/static/images/fill/bee.png"
      />
    </Container>
  );
}

export default Bee;